<div [class]="classPrefix('MainPod')">
  <wml-form [params]="mainForm"></wml-form>
  <div [class]="classPrefix('MainItem0')">
    <wml-button-zero [params]="submitBtn"></wml-button-zero>
  </div>
</div>
